import React from 'react';

const Services = () => {
    const services = [
        {
            title: 'Mobil Uygulama Geliştirme',
            description: 'iOS ve Android platformları için native ve cross-platform mobil uygulamalar geliştiriyoruz. React Native ve Flutter teknolojileri ile kullanıcı dostu uygulamalar sunuyoruz.',
            image: '/images/service-1.jpg'
        },
        {
            title: 'Web Tasarım ve Geliştirme',
            description: 'Modern ve responsive web siteleri, e-ticaret platformları ve web uygulamaları geliştiriyoruz. React, Angular ve Vue.js ile çözümler sunuyoruz.',
            image: '/images/service-2.jpg'
        },
        {
            title: 'Gömülü Sistemler',
            description: 'IoT cihazları, endüstriyel kontrol sistemleri ve akıllı ev sistemleri için gömülü yazılım çözümleri geliştiriyoruz. ARM, Arduino ve Raspberry Pi platformlarında uzmanız.',
            image: '/images/service-3.jpg'
        },
        {
            title: 'Danışmanlık Hizmetleri',
            description: 'Yazılım geliştirme süreçleri, proje yönetimi, teknoloji seçimi ve dijital dönüşüm konularında profesyonel danışmanlık hizmetleri sunuyoruz.',
            image: '/images/service-4.jpg'
        },
        {
            title: 'Kurumsal Eğitim',
            description: 'Ekibinizin teknoloji alanındaki bilgi birikimini artırmak için uzmanlarımız tarafından hazırlanan eğitim programları sunuyoruz. Yazılım geliştirme, veri analitiği ve dijital dönüşüm gibi alanlarda eğitim veriyoruz.',
            image: '/images/service-5.jpg'
        },
        {
            title: 'Özel Yazılım Geliştirme Çözümleri',
            description: 'İşletmenizin ihtiyaçlarına özel yazılım çözümleri geliştiriyoruz. ERP, CRM, otomasyon sistemleri ve diğer iş uygulamaları ile operasyonlarınızı optimize ediyoruz.',
            image: '/images/service-6.jpg'
        }
    ];

    return (
        <section id="services" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12 sm:mb-16">
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Hizmetlerimiz
                    </h2>
                    <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
                        Yazılım geliştirme sürecinin her aşamasında profesyonel hizmet sunuyoruz
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                    {services.map((service, index) => (
                        <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col">
                            <div className="relative h-48 sm:h-56 overflow-hidden">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="w-full h-full object-cover"
                                />
                            </div>

                            <div className="p-6 sm:p-8 flex flex-col flex-grow">
                                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4">
                                    {service.title}
                                </h3>

                                <p className="text-sm sm:text-base text-gray-600 leading-relaxed flex-grow">
                                    {service.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
